interface FloopLogoProps {
  size?: "sm" | "md" | "lg";
  showText?: boolean;
  className?: string;
}

export const FloopLogo = ({ size = "md", showText = true, className = "" }: FloopLogoProps) => {
  const sizes = {
    sm: { icon: 32, text: "text-lg" },
    md: { icon: 40, text: "text-xl" },
    lg: { icon: 56, text: "text-3xl" },
  };

  const { icon, text } = sizes[size];

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {/* Floop Icon - Droplet with pixels */}
      <svg
        width={icon}
        height={icon}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="shrink-0"
      >
        <defs>
          <linearGradient id="floopGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#FF6B9D" />
            <stop offset="50%" stopColor="#C084FC" />
            <stop offset="100%" stopColor="#22D3EE" />
          </linearGradient>
          <filter id="floopGlow" x="-20%" y="-20%" width="140%" height="140%">
            <feGaussianBlur stdDeviation="2" result="blur" />
            <feComposite in="SourceGraphic" in2="blur" operator="over" />
          </filter>
        </defs>
        
        {/* Main droplet shape */}
        <path
          d="M24 4C24 4 8 18 8 30C8 38.837 15.163 46 24 46C32.837 46 40 38.837 40 30C40 18 24 4 24 4Z"
          fill="url(#floopGradient)"
          filter="url(#floopGlow)"
        />
        
        {/* Pixel squares scattered */}
        <rect x="10" y="34" width="4" height="4" rx="1" fill="#FF6B9D" opacity="0.9" />
        <rect x="6" y="38" width="3" height="3" rx="0.5" fill="#22D3EE" opacity="0.8" />
        <rect x="14" y="40" width="3" height="3" rx="0.5" fill="#FBBF24" opacity="0.9" />
        <rect x="8" y="42" width="2" height="2" rx="0.5" fill="#C084FC" opacity="0.7" />
        
        {/* Highlight */}
        <ellipse cx="18" cy="20" rx="4" ry="6" fill="white" opacity="0.3" />
      </svg>

      {showText && (
        <span className={`font-display font-bold text-foreground ${text}`}>
          Floop
        </span>
      )}
    </div>
  );
};
